import { FC, memo, ReactElement, useMemo } from 'react'
import { Box, Flex, FlexProps, Heading, Text } from '@chakra-ui/react'

import { getPossibleFeedbacks } from './constants/possibleFeedbacks'

type CustomFeedbackContext =
  | 'withoutCamera'
  | 'withoutBondOption'
  | 'notLoggedIn'
  | 'onlyModulePermissions'
  | 'withoutPermission'
  | 'withoutPermissionInTheModule'
  | 'withoutMetadatas'
  | 'withoutCustomForm'

type Props = FlexProps & {
  context: CustomFeedbackContext
  title?: string
  description?: string
  children?: ReactElement
}

const CustomFeedback: FC<Props> = ({ context, title, description, children, height = '300px', ...rest }) => {
  const propsValue = useMemo(() => {
    const illustrationSize = '150px'
    const possibleFeedbacks = getPossibleFeedbacks(illustrationSize)
    return possibleFeedbacks[context]
  }, [])

  return (
    <Flex p={2} gap={4} direction="column" align="center" justify="center" height={height} {...rest}>
      <Flex direction="column" align="center" justify="center" gap={1}>
        {propsValue.Illustration}

        <Heading textAlign="center">{title || propsValue.title}</Heading>

        <Text
          fontSize="sm"
          variant="secondary"
          maxWidth={{ base: '300px', sm: '350px', md: '450px', lg: '600px' }}
          textAlign="center"
        >
          {description || propsValue.description}
        </Text>

        {children && (
          <Box minWidth="100%" mt={2}>
            {children}
          </Box>
        )}
      </Flex>
    </Flex>
  )
}

export default memo(CustomFeedback)
